import type { LearningVocabularyItem } from '@services/firebase/learning'
import {
  resolveLocalizedDisplayText,
  resolveTranslatedText,
} from '@features/learning/shared/learning-helpers'

export function resolveLearningVocabularyTitle(item: LearningVocabularyItem, locale: string) {
  return (
    resolveLocalizedDisplayText(item.title, locale) ??
    item.text ??
    resolveTranslatedText(item.translates, locale)
  )
}
